var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 12,
    fill: "#00296B",
    stroke: "#FFD600",
    strokeWidth: 2,
    strokeDasharray: "4 3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFD600",
    textAnchor: "middle"
  }, "11")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon-11.f382be6a3286fe0999ee8c63e8ff21a3.svg";
export { ForwardRef as ReactComponent };